import { playbackUrl } from "../../api/media.js";

export function VideoPlayer({ mediaId }: { mediaId: string }) {
  return (
    <video
      key={mediaId}
      controls
      autoPlay
      playsInline
      style={{ maxWidth: "100%", maxHeight: "85vh" }}
      src={playbackUrl(mediaId)}
    />
  );
}
